msgid ""
msgstr ""
"POT-Creation-Date: 2025-11-11 17:06+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/CheckConfirmationDialog.tsx:48
msgid "A vehicle could not be detected in the photo. You can retake the photo to capture the vehicle clearly, or confirm to proceed anyway."
msgstr "A vehicle could not be detected in the photo. You can retake the photo to capture the vehicle clearly, or confirm to proceed anyway."

#: src/routes/success.tsx:28
msgid "All required photos have been successfully uploaded."
msgstr "All required photos have been successfully uploaded."

#: src/components/ErrorBoundary.tsx:32
#: src/lib/errors.ts:257
#: src/lib/errors.ts:271
msgid "An unexpected error occurred"
msgstr "An unexpected error occurred"

#: src/components/IllustrationOverlay.tsx:43
#: src/components/InPageCamera.tsx:147
#: src/components/PhotoProgress.tsx:68
msgid "Back"
msgstr "Back"

#: src/components/PermissionsOverlay.tsx:87
msgid "Camera access"
msgstr "Camera access"

#: src/lib/errors.ts:338
msgid "Camera access denied. Please allow camera permissions."
msgstr "Camera access denied. Please allow camera permissions."

#: src/lib/errors.ts:345
msgid "Camera access failed. Please check permissions."
msgstr "Camera access failed. Please check permissions."

#: src/lib/errors.ts:325
msgid "Cannot access location. Please check device settings."
msgstr "Cannot access location. Please check device settings."

#: src/components/PhotoProgress.tsx:64
msgid "Capture photo"
msgstr "Capture photo"

#: src/components/PhotoPreview.tsx:27
#: src/components/PhotoProgress.tsx:43
msgid "Captured photo"
msgstr "Captured photo"

#: src/components/CheckConfirmationDialog.tsx:34
msgid "Check Result"
msgstr "Check Result"

#: src/routes/404.tsx:17
msgid "Check the link, or try again later."
msgstr "Check the link, or try again later."

#: src/lib/permissions.ts:53
msgid "Chrome does not have camera permission on this phone. Open Settings → Apps → Chrome → Permissions → Camera and choose Allow."
msgstr "Chrome does not have camera permission on this phone. Open Settings → Apps → Chrome → Permissions → Camera and choose Allow."

#: src/components/PhotoProcessingOverlay.tsx:33
msgid "Close"
msgstr "Close"

#: src/components/CheckConfirmationDialog.tsx:56
msgid "Confirm"
msgstr "Confirm"

#: src/components/CheckConfirmationDialog.tsx:54
msgid "Confirm Anyway"
msgstr "Confirm Anyway"

#: src/components/PhotoPreview.tsx:31
msgid "Confirm photo"
msgstr "Confirm photo"

#: src/components/CheckConfirmationDialog.tsx:55
msgid "Confirm VIN"
msgstr "Confirm VIN"

#: src/components/CheckConfirmationDialog.tsx:30
msgid "Confirm VIN Code"
msgstr "Confirm VIN Code"

#: src/components/CheckConfirmationDialog.tsx:115
msgid "Confirming..."
msgstr "Confirming..."

#: src/components/StepContent.tsx:104
#: src/components/StepContent.tsx:131
msgid "Continue"
msgstr "Continue"

#: src/routes/qr-landing.tsx:90
msgid "Continue on this device"
msgstr "Continue on this device"

#: src/components/IllustrationOverlay.tsx:39
msgid "Continue to camera"
msgstr "Continue to camera"

#: src/routes/qr-landing.tsx:75
msgid "Copied"
msgstr "Copied"

#: src/routes/qr-landing.tsx:80
msgid "Copy link"
msgstr "Copy link"

#: src/routes/qr-landing.tsx:86
msgid "Copying failed. Select and copy the link above."
msgstr "Copying failed. Select and copy the link above."

#: src/components/CameraErrorAlert.tsx:19
msgid "Error"
msgstr "Error"

#: src/components/CheckConfirmationDialog.tsx:84
msgid "Extracted value:"
msgstr "Extracted value:"

#: src/components/CheckConfirmationDialog.tsx:83
msgid "Extracted VIN:"
msgstr "Extracted VIN:"

#: src/hooks/useCheckConfirmation.ts:63
msgid "Failed to complete upload"
msgstr "Failed to complete upload"

#: src/components/PhotoProcessingOverlay.tsx:41
msgid "Getting GPS position..."
msgstr "Getting GPS position..."

#: src/components/BrowserPromptHint.tsx:36
msgid "If the browser asks for permission, confirm it. Check the top of the screen too."
msgstr "If the browser asks for permission, confirm it. Check the top of the screen too."

#: src/components/PermissionsOverlay.tsx:95
msgid "Location access"
msgstr "Location access"

#: src/lib/errors.ts:312
msgid "Location access denied. Please allow location permissions."
msgstr "Location access denied. Please allow location permissions."

#: src/lib/errors.ts:318
msgid "Location request timed out. Please check device settings."
msgstr "Location request timed out. Please check device settings."

#: src/components/PermissionsOverlay.tsx:80
msgid "Missing permissions:"
msgstr "Missing permissions:"

#: src/lib/errors.ts:342
msgid "No camera found. Please check device."
msgstr "No camera found. Please check device."

#: src/components/OfflineBanner.tsx:16
msgid "No internet connection. Please check your network."
msgstr "No internet connection. Please check your network."

#: src/components/StepContent.tsx:53
msgid "Offline - Cannot take photos"
msgstr "Offline - Cannot take photos"

#: src/routes/qr-landing.tsx:54
msgid "Open the camera on your smartphone, scan the QR code, tap the link, and follow the instructions."
msgstr "Open the camera on your smartphone, scan the QR code, tap the link, and follow the instructions."

#: src/components/StepContent.tsx:79
msgid "optional"
msgstr "optional"

#: src/components/PermissionsOverlay.tsx:66
msgid "Permissions Required"
msgstr "Permissions Required"

#: src/lib/uploadPhoto.ts:96
msgid "Photo does not contain GPS data. Please ensure device location service is enabled."
msgstr "Photo does not contain GPS data. Please ensure device location service is enabled."

#: src/lib/uploadPhoto.ts:204
msgid "Photo is too blurry. Please take a clearer picture."
msgstr "Photo is too blurry. Please take a clearer picture."

#: src/lib/uploadPhoto.ts:104
msgid "Photo must be taken within Estonia."
msgstr "Photo must be taken within Estonia."

#: src/lib/uploadPhoto.ts:141
msgid "Photo resolution is too high ({width}x{height}). Maximum allowed resolution is {maxWidth}x{maxHeight}."
msgstr "Photo resolution is too high ({width}x{height}). Maximum allowed resolution is {maxWidth}x{maxHeight}."

#: src/lib/uploadPhoto.ts:131
msgid "Photo resolution is too low ({width}x{height}). Minimum required resolution is {minWidth}x{minHeight}."
msgstr "Photo resolution is too low ({width}x{height}). Minimum required resolution is {minWidth}x{minHeight}."

#: src/components/StepContent.tsx:90
msgid "Photo saved"
msgstr "Photo saved"

#: src/routes/success.tsx:24
msgid "Photo Session Completed!"
msgstr "Photo Session Completed!"

#: src/hooks/usePhotoUpload.ts:126
#: src/lib/uploadPhoto.ts:273
msgid "Photo upload failed"
msgstr "Photo upload failed"

#: src/lib/uploadPhoto.ts:415
msgid "Photo validation failed. Please try again."
msgstr "Photo validation failed. Please try again."

#: src/components/StepContent.tsx:83
msgid "photos"
msgstr "photos"

#: src/components/CheckConfirmationDialog.tsx:50
msgid "Please review the check result and choose to retake or confirm."
msgstr "Please review the check result and choose to retake or confirm."

#: src/hooks/useCameraWorkflow.ts:107
msgid "Please take a new photo with the camera."
msgstr "Please take a new photo with the camera."

#: src/components/CheckConfirmationDialog.tsx:39
msgid "Please verify that the VIN code above is correct. If it's incorrect, you can retake the photo."
msgstr "Please verify that the VIN code above is correct. If it's incorrect, you can retake the photo."

#: src/components/PhotoProcessingOverlay.tsx:44
msgid "Processing photo..."
msgstr "Processing photo..."

#: src/routes/qr-landing.tsx:62
msgid "QR code"
msgstr "QR code"

#: src/components/PermissionsOverlay.tsx:115
msgid "Request Permissions"
msgstr "Request Permissions"

#: src/components/PermissionsOverlay.tsx:115
msgid "Requesting permissions..."
msgstr "Requesting permissions..."

#: src/components/StepContent.tsx:77
msgid "required"
msgstr "required"

#: src/components/SessionTimer.tsx:41
msgid "Restart"
msgstr "Restart"

#: src/routes/restart.tsx:52
msgid "Restart Session"
msgstr "Restart Session"

#: src/components/PhotoPreview.tsx:35
msgid "Retake photo"
msgstr "Retake photo"

#: src/components/CheckConfirmationDialog.tsx:101
#: src/components/PhotoProcessingOverlay.tsx:33
msgid "Retake Photo"
msgstr "Retake Photo"

#: src/routes/expired.tsx:13
msgid "Session Expired"
msgstr "Session Expired"

#: src/routes/404.tsx:13
msgid "Session not available"
msgstr "Session not available"

#: src/components/CheckConfirmationDialog.tsx:74
msgid "Session VIN:"
msgstr "Session VIN:"

#: src/components/ErrorBoundary.tsx:55
msgid "Something went wrong"
msgstr "Something went wrong"

#: src/__tests__/lib/i18n.test.ts:19
#: src/__tests__/lib/i18n.test.ts:36
#: src/__tests__/lib/i18n.test.ts:46
#: src/routes/steps.tsx:91
msgid "Start taking photos"
msgstr "Start taking photos"

#: src/components/InPageCamera.tsx:119
msgid "Starting camera..."
msgstr "Starting camera..."

#. placeholder {0}: currentStepIndex + 1
#: src/components/StepContent.tsx:113
msgid "Step {0} / {totalSteps}"
msgstr "Step {0} / {totalSteps}"

#: src/components/PhotoProcessingOverlay.tsx:43
msgid "Still getting GPS position. Move outdoors or near a window."
msgstr "Still getting GPS position. Move outdoors or near a window."

#: src/components/StepContent.tsx:55
msgid "TAKE ANOTHER PHOTO (OPTIONAL)"
msgstr "TAKE ANOTHER PHOTO (OPTIONAL)"

#: src/components/InPageCamera.tsx:139
msgid "Take photo"
msgstr "Take photo"

#: src/components/StepContent.tsx:56
msgid "TAKE PHOTO"
msgstr "TAKE PHOTO"

#: src/routes/qr-landing.tsx:50
msgid "The photo app can only be used on a smartphone."
msgstr "The photo app can only be used on a smartphone."

#: src/lib/errors.ts:234
msgid "The photo could not be processed because the browser ran out of memory. Close other tabs and try again."
msgstr "The photo could not be processed because the browser ran out of memory. Close other tabs and try again."

#: src/hooks/useCameraWorkflow.ts:190
msgid "The photo did not come back. Take it again."
msgstr "The photo did not come back. Take it again."

#: src/lib/uploadPhoto.ts:309
msgid "The uploaded photo could not be loaded. Please take the photo again."
msgstr "The uploaded photo could not be loaded. Please take the photo again."

#: src/components/CheckConfirmationDialog.tsx:45
msgid "The VIN code could not be clearly extracted from the photo. You can retake the photo for better results, or confirm to proceed anyway."
msgstr "The VIN code could not be clearly extracted from the photo. You can retake the photo for better results, or confirm to proceed anyway."

#: src/components/CheckConfirmationDialog.tsx:42
msgid "The VIN in the photo does not match the VIN for this session. Confirm anyway saves this photo."
msgstr "The VIN in the photo does not match the VIN for this session. Confirm anyway saves this photo."

#: src/components/SessionTimer.tsx:37
msgid "Time remaining: {formattedTime}"
msgstr "Time remaining: {formattedTime}"

#: src/components/PermissionsOverlay.tsx:70
msgid "To take photos of your vehicle, we need access to your camera and location."
msgstr "To take photos of your vehicle, we need access to your camera and location."

#: src/components/PermissionsOverlay.tsx:72
msgid "To take photos of your vehicle, we need access to your camera."
msgstr "To take photos of your vehicle, we need access to your camera."

#: src/components/ErrorBoundary.tsx:71
msgid "Try again"
msgstr "Try again"

#: src/components/InPageCamera.tsx:133
msgid "Turn off flashlight"
msgstr "Turn off flashlight"

#: src/components/InPageCamera.tsx:133
msgid "Turn on flashlight"
msgstr "Turn on flashlight"

#: src/routes/steps.tsx:44
msgid "Turn the device to a horizontal position and follow the instructions on the screen."
msgstr "Turn the device to a horizontal position and follow the instructions on the screen."

#: src/components/PermissionsOverlay.tsx:109
msgid "Unable to access permissions. Please enable camera access in your browser or phone settings."
msgstr "Unable to access permissions. Please enable camera access in your browser or phone settings."

#: src/components/PermissionsOverlay.tsx:108
msgid "Unable to access permissions. Please enable camera and location access in your browser or phone settings."
msgstr "Unable to access permissions. Please enable camera and location access in your browser or phone settings."

#: src/lib/uploadPhoto.ts:177
msgid "Unable to process image for quality check."
msgstr "Unable to process image for quality check."

#: src/components/StepContent.tsx:94
msgid "Up to {totalAllowed} photos allowed for this step. Additional photos are optional."
msgstr "Up to {totalAllowed} photos allowed for this step. Additional photos are optional."

#: src/components/PhotoProgress.tsx:50
msgid "Uploading photo..."
msgstr "Uploading photo..."

#: src/components/PhotoProgress.tsx:50
msgid "Validating photo..."
msgstr "Validating photo..."

#: src/components/CheckConfirmationDialog.tsx:33
msgid "Vehicle Detection Issue"
msgstr "Vehicle Detection Issue"

#: src/components/CheckConfirmationDialog.tsx:31
msgid "VIN does not match"
msgstr "VIN does not match"

#: src/components/CheckConfirmationDialog.tsx:32
msgid "VIN Extraction Issue"
msgstr "VIN Extraction Issue"

#: src/routes/steps.tsx:52
msgid "Your device or browser may not be supported. Use iOS 17 or Android 13 or newer."
msgstr "Your device or browser may not be supported. Use iOS 17 or Android 13 or newer."

#: src/routes/expired.tsx:17
msgid "Your session has expired. Please contact support for assistance."
msgstr "Your session has expired. Please contact support for assistance."

#: src/routes/restart.tsx:46
msgid "Your session needs to be restarted"
msgstr "Your session needs to be restarted"
